module.exports = __webpack_public_path__ + "img/ic-ads-account-inactive.851cab52.svg";